module.exports = (__webpack_require__(4252))(72);


//////////////////
// WEBPACK FOOTER
// delegated ./src/entries/index.js from dll-reference dibs_buyer_layout
// module id = 2319
// module chunks = 64